/**
 * Road class for rendering and managing the road
 */

import { lerp } from '../utils/geometry'
import type { Point, IRoad } from '../types'

export class Road implements IRoad {
	x: number
	width: number
	lanes: number
	left: number
	right: number
	top: number
	bottom: number
	borders: [Point, Point][]

	constructor(x: number, width: number, lanes: number = 3) {
		this.x = x
		this.width = width
		this.lanes = lanes

		this.left = x - width / 2
		this.right = x + width / 2

		const infinity = 1000000
		this.top = -infinity
		this.bottom = infinity

		const topLeft: Point = { x: this.left, y: this.top }
		const topRight: Point = { x: this.right, y: this.top }
		const bottomLeft: Point = { x: this.left, y: this.bottom }
		const bottomRight: Point = { x: this.right, y: this.bottom }

		this.borders = [
			[topLeft, bottomLeft],
			[topRight, bottomRight]
		]
	}

	getLaneCenter(laneIndex: number): number {
		const laneWidth = this.width / this.lanes
		return this.left + laneWidth / 2 + Math.min(laneIndex, this.lanes - 1) * laneWidth
	}

	draw(ctx: CanvasRenderingContext2D): void {
		ctx.lineWidth = 5
		ctx.strokeStyle = 'white'

		for (let i = 1; i < this.lanes; i++) {
			const x = lerp(this.left, this.right, i / this.lanes)

			// add dashes to the line
			ctx.setLineDash([25, 25])
			ctx.beginPath()
			ctx.moveTo(x, this.top)
			ctx.lineTo(x, this.bottom)
			ctx.stroke()
		}

		ctx.setLineDash([])
		this.borders.forEach((border) => {
			ctx.beginPath()
			ctx.moveTo(border[0]!.x, border[0]!.y)
			ctx.lineTo(border[1]!.x, border[1]!.y)
			ctx.stroke()
		})
	}
}
